import { Mixins, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import EdMeetingContainer from '@/content/components/ed-meeting-container/ed-meeting-container.component.vue';
import { MEETING_TYPES_VALUES, _MEETINGS_STORE, MEETING_EVENTS, CRYPTPAD_MEETINGS, PRESENTATION_MODE_MEETING } from '@/meetings/values/meetings.values';
import { CORE_ROUTES } from '@/core/core.router';
import { MEETINGS_VARIABLES } from '@/core/values/core.values';
import { MeetingsService } from '@/meetings/services/meetings.service';
import KEYS from '@/values/keys';
import * as PRESENTATION_VALUES from '@/content/values/ed-presentation-mode.values';
import EdPresentationModeStudent from '@/content/components/ed-presentation-mode/ed-presentation-mode-student/ed-presentation-mode-student.component.vue';
import EdPresentationModeTeacher from '@/content/components/ed-presentation-mode/ed-presentation-mode-teacher/ed-presentation-mode-teacher.component.vue';
import EdPresentationModeGuestTeacher from '@/content/components/ed-presentation-mode/ed-presentation-mode-guest-teacher/ed-presentation-mode-guest-teacher.component.vue';
import WebSocketMessageRequest from '@/content/models/web-socket-message-request.model';
import EdPresentationModeFactory from '@/content/factories/ed-presentation-mode.factory';
import { APP_SOCKET_EVENTS, APP_SOCKET_MESSAGES_TYPE, FORWARD_PRESENTATION_MESSAGES_EVENT, FORWARD_SOCKET_MESSAGES_EVENT, _APP_STORE } from '@/core/values/app.values';
import { AUTH_STORE } from '@/auth/store/auth.store';
import { ScreenMirroringService } from '@/services/screen.mirroring.service';
import { PresentationModeSessionMixin } from '@/meetings/mixins/presentation-mode-session.mixin';
import WebSocketMessageResponse from '@/content/models/web-socket-message-response.model';
import MeetingInformationResponse from '@/meetings/models/meeting-information-response.model';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { LocalStorageService } from '@/services/local-storage.service';
import { AUTH_STORAGE_KEYS } from '@/auth/values/auth.values';
import { COURSE_EVENTS } from '@/content/values/events';

@Component({
  components: {
    EdMeetingContainer,
    EdPresentationModeStudent,
    EdPresentationModeTeacher,
    EdPresentationModeGuestTeacher
  }
})
export default class InternalMeeting extends Mixins(PresentationModeSessionMixin) {

  private isShowPreview : boolean = false;
  private presentationMode : string = '';
  public roomId : number = 0;
  public classId : number = 0;
  private isShowMenu : boolean = true;

  private getSpecificMeetingServiceName : string = 'getSpecificMeetingService';
  private updateSpecificMeetingServiceName : string = 'updateSpecificMeetingService';
  private subscribeStore : Function;
  private socketConnections : string[] = [];

  get isStudentToggle() {
    return (this.$store.state.MeetingsStore.currentMeetingData.studentToggle && (!this.isPublisher || this.isPresentationModeGuestTeacher));
  }

  get isPresentationTeacherMode() : boolean {
    return this.$store.state.CourseStore.isPresentationTeacherMode;
  }

  get isReadonlyCryptpadMeeting() {
    return CRYPTPAD_MEETINGS.includes(this.$store.state.MeetingsStore.currentMeetingData.meetingType);
  }

  get currentMeetingData() {
    return this.$store.state.MeetingsStore.currentMeetingData;
  }

  get isWhiteBoard() {
    return this.currentMeetingData.meetingType === -3;
  }

  get user() : string {
    return btoa(this.$store.state.AuthStore.user.fullName);
  }

  get encodedUserId() : string {
    return btoa(this.$store.state.AuthStore.user.userId);
  }

  get isPresentationModeGuestTeacher() : boolean {
    return this.$store.state.MeetingsStore.isPresentationModeGuestTeacher;
  }

  get isValidatedPresentationModeSession() : boolean {
    return this.$store.state.MeetingsStore.isValidatedPresentationModeSession;
  }

  get presenterTeacherInformation() : MeetingInformationResponse {
    return this.$store.state.MeetingsStore.presenterTeacherInformation;
  }

  get isActivePresenterTeacher() : boolean {
    return this.$store.state.MeetingsStore.isActivePresenterTeacher;
  }

  get isOtherSession() : boolean {
    return this.$store.state.MeetingsStore.isOtherSession;
  }

  get isBoardSectionHomework() {
    return this.$store.state.CourseStore.isBoardSectionHomework;
  }

    private obtainMeetingPath(id : number, meetingId : number, currentClassId : number) : void {
        (this.$refs as any).EdLoading.show();
        switch (id) {
            case -1:
              MeetingsService.getSpecificMeetingService(meetingId, MEETING_TYPES_VALUES.TOHAINA).then((res:any) => {
                (this.$refs as any).EdLoading.hide();
                this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_MEETING_PAGE, res.url)
              }).catch(err => {
                if(err.response.status == 400 && err.response.message == MEETINGS_VARIABLES.MEETING_NOT_STARTED) {
                  (this.$refs as any).EdLoading.hide();
                  this.openWaitingRoom(meetingId, currentClassId);
                } else {
                  this.showGenericModal();
                }
              });
              this.isShowPreview = false;
              break;
            case -2:
              /**
               *  Replace Quill Editor Iframe with EdupadC omponent
               *  this.callDocumentUrl(this.getSpecificMeetingServiceName, meetingId, MEETING_TYPES_VALUES.EDUACPAD, 'padUrl', 'padUrl');
               */ 
              MeetingsService.getSpecificMeetingService(meetingId,MEETING_TYPES_VALUES.EDUACPAD).then((res:any) => {
                this.$store.commit(_MEETINGS_STORE.MUTATIONS.SET_EDUPAD_DOCUMENT, res.sessionId);
                (this.$refs as any).EdLoading.hide();
              }).catch(err => {
                this.showGenericModal();
              });
              this.isShowPreview = false;
              break;
            case -3:
              MeetingsService.getSpecificMeetingService(meetingId,MEETING_TYPES_VALUES.WHITEBOARD).then((res:any) => {
                (this.$refs as any).EdLoading.hide();
                let isGuest : boolean = !this.isPublisher || this.isPresentationModeGuestTeacher;
                // let tokenEncoded= btoa(LocalStorageService.getItem(AUTH_STORAGE_KEYS.ED_JWT));
                // this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_MEETING_PAGE, `${res.boardUrl}?lang=${this.$i18n.locale}&user=${this.user}&userName=${this.encodedUserId}&isGuest=${isGuest}&token=${tokenEncoded}`);
                this.$store.commit(_MEETINGS_STORE.MUTATIONS.SET_MEETING_SESSION_ID, res.sessionId);
              }).catch(err => {
                this.showGenericModal();
              });
              this.isShowPreview = false;
              break;
            case -4:
              this.roomId = meetingId;
              this.classId = currentClassId;
              (this.$refs as any).EdLoading.hide();
              this.setPresentationModeType();
              this.isShowPreview = true;
              break;
            case -5:
                this.callDocumentUrl(this.getSpecificMeetingServiceName, meetingId, MEETING_TYPES_VALUES.SHEET, 'sheetEditUrl', 'sheetViewUrl');
                this.isShowPreview = false;
                break;
            case -6:
                this.callDocumentUrl(this.getSpecificMeetingServiceName, meetingId, MEETING_TYPES_VALUES.SLIDE, 'slideEditUrl', 'slideViewUrl');
                this.isShowPreview = false;
                break;
            case -7:
              this.roomId = meetingId;
                 this.classId = currentClassId;
              (this.$refs as any).EdLoading.hide();
              this.setPresentationModeType();
              this.isShowPreview = true;
              break;
            default:
              (this.$refs as any).EdLoading.show();
              // this.$router.push({name: CORE_ROUTES.PRIVATE.HOME.NAME}).catch(() => {});
            break;
          }
    }

      private updateMeetingPath({ type, meetingId } : {type : string, meetingId : number}) : void {
        (this.$refs as any).EdLoading.show();
        switch (type) {
            /**
             * Replace Quill Editor Iframe with EdupadC omponent
             * case 'pad':
             *   this.callDocumentUrl(this.updateSpecificMeetingServiceName, meetingId, MEETING_TYPES_VALUES.EDUACPAD, 'padEditUrl', 'padViewUrl');
             *   break;
             */
            case 'sheet':
              this.callDocumentUrl(this.updateSpecificMeetingServiceName, meetingId, MEETING_TYPES_VALUES.SHEET, 'sheetEditUrl', 'sheetViewUrl');
              break;
            case 'slide':
              this.callDocumentUrl(this.updateSpecificMeetingServiceName, meetingId, MEETING_TYPES_VALUES.SLIDE, 'slideEditUrl', 'slideViewUrl');
              break;
            default:
              this.$router.push({name: CORE_ROUTES.PRIVATE.HOME.NAME}).catch(() => {});
            break;
          }
    }

    private callDocumentUrl (serviceName: string, meetingId: number, meetingType: string, returnName: string, viewerUrlName: string) {
      MeetingsService[serviceName](meetingId, meetingType).then((res:any) => {
        (this.$refs as any).EdLoading.hide();
        let editUrl = res[returnName] + '&readonly=false';
        let viewUrl = res[viewerUrlName]  + '&readonly=true';
        if(this.isStudentToggle) {
          this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_MEETING_PAGE, viewUrl);
        } else {
         this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_MEETING_PAGE, editUrl);
        }

        this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_CURRENT_MEETING_DATA,
          { ...this.currentMeetingData, editUrl, viewUrl});
      }).catch(err => {
        this.showGenericModal();
      });
    }

    private openWaitingRoom(meetingId: number, classId: number) {
      this.$router.push({
        name: CORE_ROUTES.WAITING_ROOM.NAME,
        params: {
          id: meetingId.toString(),
          classId: classId.toString()
        }
      });
    }

    private showGenericModal(body?){
        var bodyStr = body ? body : this.$i18n.t('meetings.homeMeetings.errorLoading');
        (this.$refs as any).EdLoading.hide()
        this.$EdModal.createMessageModal({
          title: this.$i18n.t('meetings.customizeGroups.errorTitle'),
          body: bodyStr,
          type: KEYS.EVENT_TYPES.DANGER
        });
    }

    private setPresentationModeType() : void {
      if (this.isPresentationModeGuestTeacher) {
        this.presentationMode = 'EdPresentationModeGuestTeacher';
      } else if(this.$store.state.AuthStore.role === KEYS.ROLES.BUYER){
        this.presentationMode = 'EdPresentationModeStudent';
      } else {
        this.presentationMode = 'EdPresentationModeTeacher';
      }
    }

    private changeMeetingMenu({id, meetingId, classId} :
      {id : number, meetingId : number, classId : number}) {
        if(id) {
          this.obtainMeetingPath(id, meetingId, classId);
        }
    }

    private validateParamsToInit(id : number, meetingId : number, classId : number): void {
      if (this.$store.state.AppStore.presentationSocketConnected && this.$store.state.AuthStore.user.userId) {
        this.registrySocketEvents();
        this.obtainMeetingPath(id, meetingId, classId);
        this.subscribeStore();
      }
    }

    private validateObtainInitialValues(id : number, meetingId : number, classId : number){
      if(this.$store.state.AuthStore.user.userId && this.$store.state.AppStore.presentationSocketConnected){
        this.registrySocketEvents();
        this.obtainMeetingPath(id, meetingId, classId);
      }else{
          this.validateStoreValues(id, meetingId, classId);
      }
    }

    private validateStoreValues(id : number, meetingId : number, classId : number){
      this.subscribeStore = this.$store.subscribe((mutation) => {
        if(mutation.type === _APP_STORE.MUTATIONS.SET_PRESENTATION_SOCKET_CONNECTED || mutation.type === AUTH_STORE.MUTATIONS.SET_USER_INFO) {
          this.validateParamsToInit(id, meetingId, classId);
        }
      });
    }

    private registrySocketEvents() : void {
      if(this.isPresentationModeGuestTeacher){
        this.connectGuestTeacher();
        this.userMeetingConnected();
        this.meetingConnected();
        this.meetingTextChanged();
      } else if(this.isPublisher){
        this.userMeetingConnected();
        this.meetingTextChanged();
      }
    }

    private meetingTextChanged(): void {
      const socketSubscriptionName: string = APP_SOCKET_EVENTS.MEETING_EVENTS.replace('{roomId}', String(this.roomId));
      this.$EdSocket.on(socketSubscriptionName, (message: WebSocketMessageResponse) => {
        if ((PRESENTATION_VALUES.EVENT_TYPES.text === message?.messageType) && message?.content) {
          const textData: any = JSON.parse(message.content);
          this.$edEventBus.$emit(COURSE_EVENTS.TEXT_CHANGED, textData);
        }
      });
    }

    private userMeetingConnected() : void {
      let socketSubscriptionName : string = `${PRESENTATION_VALUES.SOCKET_EVENTS.response}${this.$store.state.AuthStore.user.userId}`;
      this.$EdSocket.on(socketSubscriptionName, (message : WebSocketMessageResponse) => {
        if(this.isPublisher && !this.isPresentationModeGuestTeacher){
          this.validateTeacherMessages(message);
        } else {
          this.validateGuestUserMessage(message, this.roomId);
        }
      });
      this.socketConnections.push(socketSubscriptionName);
    }

  private meetingConnected() : void {
    let socketSubscriptionName : string = APP_SOCKET_EVENTS.MEETING_EVENTS.replace('{roomId}', String(this.roomId));
    this.$EdSocket.on(socketSubscriptionName, this.validateEvent);
    this.socketConnections.push(socketSubscriptionName);
  }

  private validateEvent(message : WebSocketMessageResponse) : void {
    if (message && message.messageType && message.userType === KEYS.ROLES_MAPPED.PUBLISHER){
      if(message.messageType === APP_SOCKET_MESSAGES_TYPE.LEAVE) {
        this.$edEventBus.$emit(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.LEAVE_TEACHER_EVENT);
      } else {
        this.$edEventBus.$emit(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.RESPONSE_EVENT, { ...message, topicId: this.roomId});
      }
    }
  }

  private validateTeacherMessages(message : WebSocketMessageResponse) : void {
    if(message && message.topicId.toString() === this.roomId.toString()){
      if(message.messageType === PRESENTATION_VALUES.EVENT_TYPES.userConnect && message.userType === PRESENTATION_VALUES.GUEST_TACHER_ROLE){
        this.$EdToast.create({
          msg: this.$t('meetings.presentationMode.guestTeacherJoined').toString().replace('{name}', message.name),
          type: TOAST_TYPES.WARNING,
          top: '3rem',
          timeout: 5000
        });
      }else {
        this.$edEventBus.$emit(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.RESPONSE_USER_EVENT, message);
      }
    }
  }

  private async forwardMessages() : Promise<void> {
    let validSession : boolean = await this.validateSession(this.roomId, true);
    if(!validSession){
      return;
    }

    if(this.isPresentationModeGuestTeacher){
      this.showLoading();
      this.connectGuestTeacher();
      if(!this.isActivePresenterTeacher){
        this.$edEventBus.$emit(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.LEAVE_TEACHER_EVENT);
      }
      this.hideLoading();
    }
    this.$edEventBus.$emit(FORWARD_PRESENTATION_MESSAGES_EVENT);
  }

  private connectGuestTeacher() : void {
    let message: WebSocketMessageRequest = EdPresentationModeFactory.createWebSocketMessageRequestWithUserType(
      PRESENTATION_VALUES.EVENT_TYPES.userConnect, String(this.roomId), PRESENTATION_VALUES.GUEST_TACHER_ROLE, false, '', this.presenterTeacherInformation.presenter);
    this.$EdSocket.emit(PRESENTATION_VALUES.SOCKET_EVENTS.guestTeacherConnect, message);
  }

  private sendLeaveMessage() : void {
    let message : WebSocketMessageRequest = EdPresentationModeFactory.createWebSocketMessageRequest(PRESENTATION_VALUES.EVENT_TYPES.studentDisconnect, String(this.roomId), false);
    this.$EdSocket.emit(PRESENTATION_VALUES.SOCKET_EVENTS.leaveStudent, message);
  }

    public async loadNewRoom(): Promise<void> {
      const params = this.$route.params;
      if(!(params && params.id && params.meetingId)) {
        this.$router.push({name: CORE_ROUTES.PRIVATE.HOME.NAME}).catch(() => {});
        return;
      }

      let id = parseInt(params.id);
      let meetingId = parseInt(params.meetingId);
      let classId = parseInt(params.classId);

      if(!this.isValidatedPresentationModeSession){
        let validSession : boolean = await this.validateSession(meetingId, false);
        if(!validSession){
          return;
        }
      }

      this.roomId = meetingId;

      if(this.isPublisher && !this.isPresentationModeGuestTeacher) {
        this.$Courses.Store.setPresentationTeacherMode({
          isPresentationTeacherMode: true
        })
      }

      this.$edEventBus.$on(FORWARD_SOCKET_MESSAGES_EVENT, this.forwardMessages);

      this.isShowMenu = (typeof params.showMenu !== 'undefined') ? (params.showMenu === 'true') : true;
      this.validateObtainInitialValues(id, meetingId, classId);


      if(id === PRESENTATION_MODE_MEETING) {
        this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_CURRENT_MEETING_DATA,
          {classId : classId, meetingId : meetingId, meetingType : -4, studentToggle : true});
        this.$edEventBus.$on(MEETING_EVENTS.CHANGE_MEETING_SHORT_MENU, this.changeMeetingMenu);
        this.$edEventBus.$emit(PRESENTATION_VALUES.SEND_READ_ONLY_STATE_EVENT);
        this.$edEventBus.$emit(PRESENTATION_VALUES.VALIDATE_PRESENTATION_STUDENT_CONNECT_EVENT);
      }

      this.$edEventBus.$on(MEETING_EVENTS.UPDATE_DOCUMENT_URL, this.updateMeetingPath);
      this.$store.commit(_MEETINGS_STORE.MUTATIONS.SET_MAIN_MEETING_TYPE, id);

    }

    roomChanged() {
      this.$App.Store.setHeaderVisible(true);
      this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_CURRENT_MEETING_DATA, {classId : 0, meetingId : 0, meetingType : null});
      this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_PRESENTATION_NAVIGATION, true);
      this.$edEventBus.$off(MEETING_EVENTS.CHANGE_MEETING_SHORT_MENU, this.changeMeetingMenu);
      this.$edEventBus.$off(MEETING_EVENTS.UPDATE_DOCUMENT_URL, this.updateMeetingPath);
      this.$edEventBus.$off(FORWARD_SOCKET_MESSAGES_EVENT, this.forwardMessages);
      if(this.isStudent){
        this.sendLeaveMessage();
      }
      if(this.isPresentationTeacherMode) {
        this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_PRESENTATION_MODE_USER_FILTER, true);
        this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_WHITEBOARD_TRANSPARENCY, false);
        this.$edEventBus.$emit(PRESENTATION_VALUES.RESET_TRANSPARENCY_EVENT);
        this.$edEventBus.$emit(PRESENTATION_VALUES.RESET_READ_ONLY_EVENT);

        if(!this.isActivePresenterTeacher){
          const message: WebSocketMessageRequest = EdPresentationModeFactory.createWebSocketMessageRequest(
            APP_SOCKET_MESSAGES_TYPE.LEAVE,
            String(this.roomId),
            false,
            null
          );
          this.$EdSocket.emit(PRESENTATION_VALUES.SOCKET_EVENTS.leave, message);
        }
      }

      if(this.isPresentationModeGuestTeacher){
        if(!this.isOtherSession){
          const message: WebSocketMessageRequest = EdPresentationModeFactory.createWebSocketMessageRequestWithUserType(
            APP_SOCKET_MESSAGES_TYPE.LEAVE,
            String(this.roomId),
            PRESENTATION_VALUES.GUEST_TACHER_ROLE
          );
          this.$EdSocket.emit(PRESENTATION_VALUES.SOCKET_EVENTS.guestTeacherLeave, message);
        }

        this.socketConnections.forEach(eventName => this.$EdSocket.off(eventName));
        this.socketConnections = [];
      }

      if(this.isPublisher){
        this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_PRESENTATION_MODE_GUEST_TEACHER, false);
      }
      this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_VALIDATE_PRESENTATION_SESSSION, false);
      this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_OTHER_SESSION, false);
      this.$Courses.Store.setPresentationTeacherMode({ isPresentationTeacherMode: false });
      this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_PRESENTER_TEACHER_INFORMATION, null);
      this.$store.commit(_MEETINGS_STORE.MUTATIONS.UPDATE_SHOWING_CHANGE_PRESENTER, false);
    }

    beforeDestroy() {
      this.roomChanged();
    }

    @Watch('$route.params.meetingId',  { immediate: true })
    setNewMeeting() {
      this.roomChanged();
      this.loadNewRoom();
    }
}
